const canIUseMap = new Map()

const isEdge = () => {
    return /\sEdge\/\d+/.test(window.navigator.userAgent)
}

const isInternetExplorer = () => {
    return /\sTrident\/\d+/.test(window.navigator.userAgent)
}

export const isSafari = /^((?!chrome|android).)*safari/i.test(
    navigator.userAgent
)

export const isFirefox = (window.mozInnerScreenX != null)

export const canIUseScrollToOptions = () => {
    const key = 'scrollOptions'
    if (canIUseMap.has(key)) {
        return canIUseMap.get(key)
    }

    const result = !isEdge() && !isInternetExplorer()
    canIUseMap.set(key, result)

    return canIUseMap.get(key)
}

export const canIUseCSSProperty = (prop, value) => {
    // Check if this has been tested
    const key = `css:${prop}:${value}`
    if (canIUseMap.has(key)) {
        return canIUseMap.get(key)
    }

    // Test calc on an element
    const el = document.createElement('div')
    el.style[prop] = value
    canIUseMap.set(key, !!el.style.length)

    // Return result
    return canIUseMap.get(key)
}
